(() => {
  const SECTION_ID = 'lazy-localization';
  let panelLoaded = false;
  let loading = false;

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function openPanel() {
    const panel = document.querySelector('[data-lazy-localization-panel]');
    if (!panel) return;

    panel.classList.add('is-open');
    document.documentElement.classList.add('lazy-localization-open');
  }

  function closePanel() {
    const panel = document.querySelector('[data-lazy-localization-panel]');
    if (!panel) return;

    panel.classList.remove('is-open');
    document.documentElement.classList.remove('lazy-localization-open');
  }

  function bindPanelEvents() {
    document.querySelectorAll('[data-lazy-localization-close]').forEach((button) => {
      button.addEventListener('click', closePanel);
    });

    document.querySelectorAll('.lazy-localization-form select').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel();
      }
    });
  }

  async function loadPanel() {
    if (panelLoaded || loading) {
      openPanel();
      return;
    }

    loading = true;

    try {
      const response = await fetch(`${getRootUrl()}?section_id=${SECTION_ID}`, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Failed to load localization section');
      }

      const html = await response.text();

      const mount = document.querySelector('[data-lazy-localization-mount]');
      if (!mount) return;

      mount.innerHTML = html;
      panelLoaded = true;

      bindPanelEvents();
      openPanel();
    } catch (error) {
      console.error(error);
    } finally {
      loading = false;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lazy-localization-trigger]');
    if (!trigger) return;

    event.preventDefault();
    loadPanel();
  });
})();